import React from 'react';
import { Navigate } from 'react-router-dom';
import orgService from '../services/orgService';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  /** Roles that are allowed to access this route (e.g. ['administrator'], ['admin']) */
  allowedRoles: string[];
}

/**
 * Protects routes by role. Only users whose role is in allowedRoles can access the content.
 * Others are redirected to the dashboard home.
 */
const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ children, allowedRoles }) => {
  const role = orgService.getRole();
  const normalizedRole = role?.toLowerCase().trim() ?? '';
  const isAllowed = allowedRoles.some(
    (r) => r.toLowerCase().trim() === normalizedRole
  );

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
